export default __webpack_public_path__ + "static/media/Rectangle3.69cc9a65.jpg";